import React, { useState } from 'react';
import logo from '../assets/logo.png';
import styles from './AuthPage.module.css';
import TermosModal from '../components/TermosModal';

const initialForm = {
  whatsapp: '',
  empresa: '',
  cnpj: '',
  senha: '',
};

export default function AuthPage({ mode, onToggleMode, onLogin, onRegister, loading, erro }) {
  const [form, setForm] = useState(initialForm);
  const [localError, setLocalError] = useState(null);
  const [termosAceitos, setTermosAceitos] = useState(false);
  const [showTermos, setShowTermos] = useState(false);

  const isLogin = mode === 'login';

  async function handleSubmit(event) {
    event.preventDefault();
    setLocalError(null);

    if (!form.whatsapp.trim() || !form.senha.trim()) {
      setLocalError('Informe WhatsApp e senha.');
      return;
    }

    if (!isLogin && (!form.empresa.trim() || !form.whatsapp.trim())) {
      setLocalError('Informe o nome da empresa e o WhatsApp.');
      return;
    }

    if (isLogin) {
      await onLogin({ whatsapp: form.whatsapp, senha: form.senha });
      return;
    }

    if (!isLogin && !termosAceitos) {
      setLocalError('Você precisa aceitar os Termos de Uso para criar uma conta.');
      return;
    }

    await onRegister({
      cnpj: form.cnpj,
      empresa: form.empresa,
      whatsapp: form.whatsapp,
      senha: form.senha,
    });
  }

  function updateField(field, value) {
    setForm((current) => ({ ...current, [field]: value }));
  }

  return (
    <div className={styles.page}>
      {/* Logo Header */}
      <header className={styles.logoHeader}>
        <div className={styles.logoWrapper}>
          <img src={logo} alt="AnaliseCentral" className={styles.logo} />
        </div>
      </header>

      <main className={styles.shell}>
        {/* Hero Section */}
        <section className={styles.hero}>
          <span className={styles.badge}>Consulta Rápida & Segura</span>
          <h1 className={styles.title}>
            Localize dados <br />
            com <span className={styles.titleAccent}>precisão total</span>.
          </h1>

          <div className={styles.highlights}>
            <div className={styles.highlightCard}>
              <strong>Inteligência Antifraude</strong>
              <span>Dados para garantir vendas seguras e validação cadastral eficiente.</span>
            </div>
            <div className={styles.highlightCard}>
              <strong>Acesso Instantâneo</strong>
              <span>Crie sua conta rápido e simples e em segundos comece a pesquisar.</span>
            </div>
          </div>
        </section>

        {/* Form Card */}
        <section className={styles.card}>
          {/* 🔥 NOVO: Tabs de navegação explícitas */}
          <div className={styles.tabs}>
            <button
              type="button"
              className={`${styles.tab} ${isLogin ? styles.tabActive : ''}`}
              onClick={() => !isLogin && onToggleMode()}
              aria-pressed={isLogin}
            >
              Entrar
            </button>
            <button
              type="button"
              className={`${styles.tab} ${!isLogin ? styles.tabActive : ''}`}
              onClick={() => isLogin && onToggleMode()}
              aria-pressed={!isLogin}
            >
              Criar conta
            </button>
          </div>

          {/* Subtítulo contextual */}
          <div className={styles.cardHeader}>
            <h2>
              {isLogin ? 'Bem-vindo de volta!' : 'Comece sua jornada'}
            </h2>
            <p className={styles.cardSub}>
              {isLogin
                ? 'Acesse sua conta para continuar consultando.'
                : 'Preencha os dados abaixo para criar sua empresa.'}
            </p>
          </div>

          <form className={styles.form} onSubmit={handleSubmit}>
            {!isLogin && (
              <label className={styles.field}>
                <span>Nome da empresa</span>
                <input
                  type="text"
                  value={form.empresa}
                  onChange={(event) => updateField('empresa', event.target.value)}
                  placeholder="Ex: Minha Empresa LTDA"
                  autoComplete="organization"
                />
              </label>
            )}

            {!isLogin && (
              <label className={styles.field}>
                <span>CNPJ</span>
                <input
                  type="text"
                  value={form.cnpj}
                  onChange={(event) => updateField('cnpj', event.target.value)}
                  placeholder="00.000.000/0001-00"
                  autoComplete="off"
                />
              </label>
            )}

            <label className={styles.field}>
              <span>WhatsApp</span>
              <input
                type="tel"
                value={form.whatsapp}
                onChange={(event) => updateField('whatsapp', event.target.value)}
                placeholder="(00) 00000-0000"
                autoComplete="tel"
              />
            </label>

            <label className={styles.field}>
              <span>Senha</span>
              <input
                type="password"
                value={form.senha}
                onChange={(event) => updateField('senha', event.target.value)}
                placeholder="Sua senha segura"
                autoComplete={isLogin ? 'current-password' : 'new-password'}
              />
            </label>

            {(localError || erro) && (
              <div className={styles.error}>{localError || erro}</div>
            )}

            {!isLogin && (
              <label className={styles.checkboxField}>
                <input
                  type="checkbox"
                  checked={termosAceitos}
                  onChange={(e) => setTermosAceitos(e.target.checked)}
                />
                <span>
                  Li e aceito os{' '}
                  <button
                    type="button"
                    className={styles.termosLink}
                    onClick={() => setShowTermos(true)}
                  >
                    Termos de Uso e Privacidade
                  </button>
                </span>
              </label>
            )}

            <button
              className={styles.submitButton}
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className={styles.spinner} />
                  Processando...
                </>
              ) : isLogin ? (
                'Entrar na plataforma →'
              ) : (
                'Criar minha conta →'
              )}
            </button>

            {/* 🔥 NOVO: Link secundário mobile-friendly abaixo do botão */}
            <button
              type="button"
              className={styles.switchLink}
              onClick={onToggleMode}
            >
              {isLogin
                ? 'Ainda não tem conta? Cadastre-se gratuitamente'
                : 'Já tem uma conta? Faça login'}
            </button>
          </form>
          <TermosModal
            isOpen={showTermos}
            onClose={() => setShowTermos(false)}
            onAccept={() => {
              setTermosAceitos(true);
              setShowTermos(false);
            }}
          />
        </section>
      </main>
    </div>
  );
}